/* @ngInject */

export default ($q, logger, lendersDataFactory, authenticationService) => {
  /**
   * Clear all data from cache.
   */
  const clearCache = () => {
    logger.log('lendersService', 'clearCache', 'Resolving DataFactory');
    lendersDataFactory.clearCache();
  };

  /**
   * Get the available Lender(s).
   *
   * @param {Object} [params]
   * @param {String} [params.type] - Include only Lender(s) with given type
   * @param {Boolean} [params.ignoreCache] - Ignore cache for this request.
   *
   * @returns {Array}
   */
  const getAvailable = (params) => {
    const deferred = $q.defer();
    if (!authenticationService.isAuthenticated()) {
      logger.error('lendersService', 'getAvailable', 'Not authenticated');
      deferred.reject();
    } else {
      logger.log('lendersService', 'getAvailable', 'Resolving DataFactory');
      lendersDataFactory.getAvailable(params).then((data) => {
        logger.log(`lendersService | getAvailable | Resolved ${data.length} objects`);
        deferred.resolve(data);
      });
    }
    return deferred.promise;
  };

  /**
   * Get specific Lender(s).
   *
   * @param {Object} [params]
   * @param {Object[]} [params.idLenders] - Include only Lender(s) with given IDs.
   * @param {Boolean} [params.ignoreCache] - Ignore cache for this request.
   *
   * @returns {Array}
   */
  const getSpecific = (params) => {
    const deferred = $q.defer();
    if (!authenticationService.isAuthenticated()) {
      logger.error('lendersService', 'getSpecific', 'Not authenticated');
      deferred.reject();
    } else {
      logger.log('lendersService', 'getSpecific', 'Resolving DataFactory');
      lendersDataFactory.getSpecific(params).then((data) => {
        logger.log(`lendersService | getSpecific | Resolved ${data.length} objects`);
        deferred.resolve(data);
      });
    }
    return deferred.promise;
  };

  /**
   * Get documents.
   *
   * @param {Object} [params]
   * @param {Object[]} [params.idLenders] - Include only Lender's documents with given IDs.
   * @param {Object[]} [params.types] - Include only Lender's documents with given types.
   * @param {Boolean} [params.ignoreCache] - Ignore cache for this request.
   *
   * @returns {Array}
   */
  const getDocuments = (params) => {
    const deferred = $q.defer();
    if (!authenticationService.isAuthenticated()) {
      logger.error('lendersService', 'getDocuments', 'Not authenticated');
      deferred.reject();
    } else {
      logger.log('lendersService', 'getDocuments', 'Resolving DataFactory');
      lendersDataFactory.getDocuments(params).then((data) => {
        logger.log(`lendersService | getDocuments | Resolved ${data.length} objects`);
        deferred.resolve(data);
      });
    }
    return deferred.promise;
  };

  /**
   * Get calculator.
   *
   * @returns {Promise}
   */
  const getCalculator = (doc) => {
    logger.log('lendersService', 'getCalculator', 'Resolving DataFactory');
    lendersDataFactory.getCalculator(doc);
  };

  /**
   * Get maximum borrowing.
   *
   * @param {Object} [params]
   * @param {Object[]} [params.idLenders] - Include only Lender(s) with given IDs.
   * @param {Boolean} [params.ignoreCache] - Ignore cache for this request.
   *
   * @returns {Array}
   */
  const getMaximumBorrowing = (params) => {
    const deferred = $q.defer();
    if (!authenticationService.isAuthenticated()) {
      logger.error('lendersService', 'getMaximumBorrowing', 'Not authenticated');
      deferred.reject();
    } else {
      logger.log('lendersService', 'getMaximumBorrowing', 'Resolving DataFactory');
      lendersDataFactory.getMaximumBorrowing(params).then((data) => {
        logger.log(`lendersService | getMaximumBorrowing | Resolved ${data.length} objects`);
        deferred.resolve(data);
      });
    }
    return deferred.promise;
  };

  /**
   * Get LMI.
   *
   * @param {Object} [params]
   * @param {Object[]} [params.idLenders] - Include only Lender(s) with given IDs.
   * @param {Boolean} [params.ignoreCache] - Ignore cache for this request.
   *
   * @returns {Array}
   */
  const getLmi = (params) => {
    const deferred = $q.defer();
    if (!authenticationService.isAuthenticated()) {
      logger.error('lendersService', 'getLmi', 'Not authenticated');
      deferred.reject();
    } else {
      logger.log('lendersService', 'getLmi', 'Resolving DataFactory');
      lendersDataFactory.getLmi(params).then((data) => {
        logger.log(`lendersService | getLmi | Resolved ${data.length} objects`);
        deferred.resolve(data);
      });
    }
    return deferred.promise;
  };

  /**
   * Get residential estimate.
   *
   * @param {Object} [params]
   * @param {Object[]} [params.idLenders] - Include only Lender(s) with given IDs.
   * @param {Boolean} [params.ignoreCache] - Ignore cache for this request.
   *
   * @returns {Array}
   */
  const getResidentialEstimate = (params) => {
    const deferred = $q.defer();
    if (!authenticationService.isAuthenticated()) {
      logger.error('lendersService', 'getResidentialEstimate', 'Not authenticated');
      deferred.reject();
    } else {
      logger.log('lendersService', 'getResidentialEstimate', 'Resolving DataFactory');
      lendersDataFactory.getResidentialEstimate(params).then((data) => {
        logger.log(`lendersService | getResidentialEstimate | Resolved ${data.length} objects`);
        deferred.resolve(data);
      });
    }
    return deferred.promise;
  };

  return {
    clearCache,
    getAvailable,
    getSpecific,
    getDocuments,
    getCalculator,
    getMaximumBorrowing,
    getLmi,
    getResidentialEstimate
  };
};
